import { ConsoleLogger } from '@microsoft/signalr/dist/esm/Utils';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { reportDWH } from '../../PersonalAreaInvoicesSlice';

  const keyMapMeterParams = {
    meterNumber: 'מספר מונה',
    model: 'דגם מונה',
    kva: 'נתוני KVA',
    kvaMultiFact: 'גורם הכפלה',
    voltage: 'מתח',
    meterCurRead: 'קריאה מונה נוכחית',
    meterPrevRead: 'קריאה  מונה קודמת',
    iecRatePlan: 'סוג מונה',
  };


 function PopUpInfo(props) {
    useEffect(()=>{
      props.reportDWH({ actionType: 'Invoice Page', status: 'Ongoing', messageText: props.titlePopUp === 'ההודעות שלך' ?  'Invoice Message Displayed' : 'Invoice Insights List Displayed' });
    },[])

    if(props.typePopUp){
      let keyMap = {};
      if(props.typePopUp === 'METER_DETAILS'){
        keyMap = keyMapMeterParams;
      }
      return (<div className='wrapper-mes'>
        <div className='title'>{props?.titlePopUp}</div>
        {props?.detailsPopUp && Object.entries(props?.detailsPopUp).map(([key, value], i) => {
          return( value ?
          <div key={i} className='mes'>
            {keyMap[key] && <div className='param'>
            <span className='param-key'>{keyMap[key]} :</span> <span className='param-value'>{value}&nbsp;</span></div>}
          </div> : null )
        })}
      </div>
      );
    }
    else{
      const flattenedDetails = props?.detailsPopUp?.flat();
      return (
        <div className='wrapper-mes'>
          <div className='title'>{props?.titlePopUp}</div>
          {flattenedDetails.map((item,i)=>(
            <>
              <div key={i} className='mes'>
                {/* {props.isEnergy && flattenedDetails.length > 1 && <span style={{marginLeft: 6}}>•</span>} */}
                {item}
              </div>
              {props.isEnergy && (flattenedDetails.length != ( i + 1 )) && !item.startsWith('*')  && <div className='separator'></div>}
            </>
          ))}
        </div>
      );
    }

};

const mapStateToProps = (state) => {
  return {
    detailsPopUp: state.personalAreaInvoicesPage.detailsPopUp,
    titlePopUp: state.personalAreaInvoicesPage.titlePopUp,
    typePopUp: state.personalAreaInvoicesPage.typePopUp,
    isEnergy: state.personalAreaInvoicesPage.isEnergy
  };
};

const mapDispatchToProps = {
  reportDWH
};

export default connect(mapStateToProps, mapDispatchToProps)(PopUpInfo);
